<template>
  <b-modal
    id="destroy-order-modal"
    :modal-class="'default-modal'"
    :hide-footer="true"
    @shown="shown"
    @hidden="hidden"
  >
    <AlertWraper
      :content="content"
      :type="content_type"
    />
    <div class="text-center mt-3">
      <template v-if="order">
        <div class="mb-4">
          <i class="fa fa-warning font-size-large text-warning"></i>
        </div>
        <div class="text-center">
          <h2 class="highlighted-color1">
            <span>{{ $t('delete_payment') }}</span>
          </h2>
        </div>
        <p>{{ $t('want_to_delete_the_payment.0') }} <strong>{{ order.amount/ 100 | formatMoney(order.advertiser.currency) }}</strong> {{ $t('want_to_delete_the_payment.1') }} <strong>{{ order.advertiser.name }}</strong>?</p>
        <p>{{ $t('action_irreversible') }}</p>
        <Button
          type="button"
          class="btn-color10 mt-4"
          @click="submit"
          :loading="loader"
        >
          {{ $t('delete_payment') }}
        </Button>
      </template>
    </div>
  </b-modal>
</template>

<script>

import NotificationService from '@/modules/notifications/services/notifications-service'
import OrdersService from '@/modules/orders/services/orders-service'
import { parseErrorResponseToArray } from '@/utils'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import Button from '@/components/common/Button/Button'

export default {
  name: 'DestroyOrderModal',
  props: ['order'],
  components: {
    AlertWraper,
    Button
  },
  data () {
    return {
      content: null,
      content_type: 'error',
      loader: false
    }
  },
  methods: {
    /**
     * On modal hidden
     */
    hidden () {
    },
    /**
     * On modal shown
     */
    shown () {
    },
    /**
     * Get order
     */
    async submit () {
      this.loader = true
      try {
        await OrdersService.destroyOrder(this.order.id)
        const notification = {
          notification: {
            type: 'success',
            content: this.$t('payment_deleted_successfully')
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
        this.$emit('order-destroyed', this.order)
        this.$bvModal.hide('destroy-order-modal')
      } catch (error) {
        this.content = parseErrorResponseToArray(error)
      }
      this.loader = false
    }
  }
}
</script>
